// extracted by mini-css-extract-plugin
export default {"tupacGrid":"kk-z","tupacHeader":"lk-z","tupacHeader2":"mk-z","tupacMenu":"nk-z","tupacMenu2":"ok-z","tupacMain":"pk-z","tupacMain2":"qk-z"};